/**
 * PD-4676 — Post-authentication landing redirect.
 *
 * The eligible user types (CAMPAIGN_LANDING_TYPES) land on the Campaigns
 * section after authenticating. Every other user type keeps the previous
 * default landing (the dashboard), so the auth flow is unchanged for them.
 *
 * The Graphic Designer role is a special case that lands on the Social Boost
 * Campaigns section instead, so it is short-circuited before the campaigns
 * check.
 *
 * The user-type slug is passed in explicitly (from the login response
 * payload, e.g. data.user_data.type.slug) so the redirect does not depend on
 * the store having been hydrated yet — it stays correct even if auth/LOGIN
 * later becomes asynchronous.
 */

// User-type slug that lands on the Social Boost Campaigns section.
export const SOCIAL_BOOST_LANDING_TYPE = 'graphic-designer'

// Single source of truth for the user-type slugs that land on Campaigns.
export const CAMPAIGN_LANDING_TYPES = [
  'enterprise',
  'admin',
  'agency',
  'cs-creator',
  'agency-client',
  'employee',
  'professional',
  'brand-admin',
  'brand-employee',
  'agency-employee',
  'project-manager',
]

/**
 * Push the user to their post-authentication landing route.
 *
 * @param {import("vue-router").default} router - the app router instance ($router)
 * @param {?string} slug - the authenticated user's type slug (data.user_data?.type?.slug)
 */
const redirectAfterAuth = (router, slug) => {
  let routeName = 'dashboard'

  if (slug === SOCIAL_BOOST_LANDING_TYPE) {
    // Graphic Designers land on the Social Boost Campaigns section.
    routeName = 'social-boost'
  } else if (CAMPAIGN_LANDING_TYPES.includes(slug)) {
    routeName = 'campaigns'
  }

  // router.push returns a promise that rejects on redundant/aborted
  // navigation (vue-router NavigationDuplicated). Swallow it so it does not
  // surface as an unhandled rejection.
  router.push({ name: routeName }).catch(() => {})
}

export default redirectAfterAuth
